export interface SDKConfig {
  sandbox: boolean;
  sandboxPaymentUrl: string;
  productionPaymentUrl: string;
}

const DEFAULT_CONFIG: SDKConfig = {
  sandbox: true,
  sandboxPaymentUrl: "https://pay-dev.ojire.com/pay",
  productionPaymentUrl: "https://pay.ojire.com/pay",
};

let currentConfig: SDKConfig = { ...DEFAULT_CONFIG };

export function configure(config: Partial<SDKConfig>): void {
  currentConfig = { ...currentConfig, ...config };
}

export function getConfig(): SDKConfig {
  return currentConfig;
}

export function getPaymentUrl(paymentId: string): string {
  const baseUrl = currentConfig.sandbox
    ? currentConfig.sandboxPaymentUrl
    : currentConfig.productionPaymentUrl;

  return `${baseUrl}/${paymentId}`;
}

export function isSandboxMode(): boolean {
  return currentConfig.sandbox;
}
